import SutterGround from "../../assets/company/observatories/sutter images/tkoFirstLight.png";
import SutterGroundGlamour from "../../assets/company/observatories/sutter images/tkoGlamourShot.jpg";
import SutterSpace from "../../assets/capabilities/detect/detect-2.png";

import Capture1 from "../../assets/capabilities/capture/capture-1.png";
import Capture2 from "../../assets/capabilities/capture/capture-2.png";
import Capture3 from "../../assets/capabilities/capture/capture-3.png";
import CaptureNew from "../../assets/capabilities/capture/capture-new.png";

import React from "react";
import { Link } from "react-router-dom";

export const capabilitiesData = {
  detecting: {
    title: "Sutter™ Telescope Technology",
    titleAbove: true,
    heroCards: [
      {
        title: "Theia Detection Software",
        description: (
          <>
            Our patented{" "}
            <Link className="link" to="/products/theia">
              Theia
            </Link>{" "}
            software unlocks breakthrough detection capabilities using in-situ computate, both and the ground or in space
          </>
        ),
      },
      {
        title: "Sutter Turnkey Observatory",
        description: (
          <>
            Rapidly deployable{" "}
            <Link className="link" to="/products/tko">
              Sutter TKO
            </Link>{" "}
            robotic observatories deliver next-gen detection capabilities
          </>
        ),
      },
      {
        title: "Uncued Detections",
        description: "Unmatched capability for tipping and cuing on previously unknown objects without prior tracking data",
      },
    ],
    content: [
      {
        href: SutterGround,
      },
      {
        title: "Sutter Ground",
        cardsPosition: "bottom",
        cards: [
          {
            description: (
              <>
                <Link className="link" to="/products/tko">
                  Sutter TKO
                </Link>{" "}
                Turnkey Observatories use off-the-shelf hardware packaged into advanced robotic observatories
              </>
            ),
          },
          {
            description: "Nightly asteroid and spacecraft surveys with regular detection reports",
          },
          {
            description: "Delivers next-gen capabilities faster and more affordably than traditional observatories",
          },
        ],
        href: SutterGroundGlamour,
      },
      {
        title: "Sutter Space",
        cardsPosition: "bottom",
        cards: [
          {
            description: "Breakthrough computational efficiency for space-based operations",
          },
          {
            description: "Runs on small on-board computers with minimal power requirements",
          },
          {
            description: "Minimizes downlink data rates by transmitting only detections",
          },
        ],
        href: SutterSpace,
      },
    ],
  },
  capturing: {
    title: "Flight-Ready Capture Technology",
    titleAbove: true,
    cardsPosition: "bottom",
    heroCards: [
      {
        title: "Flight-Demonstrated Technology",
        description: "Successfully deployed on the International Space Station in October 2025",
      },
      {
        title: "Cost-Effective Remediation",
        description: "Costs 6× less than de-orbiting debris, uses 80% less propellant, and clears orbits 40% faster by turning debris into valuable resources",
      },
      {
        title: "Scalable for Asteroid Mining",
        description: "Designed with forward heritage to capture asteroids - handles objects from cubesats to entire rocket bodies",
      },
    ],
    content: [
      {
        title: "Payloads for Host Spacecraft",
        cardsPosition: "bottom",
        cards: [
          {
            description: "Rip-stop inflatable bags enclose and secure uncooperative targets",
          },
          {
            description: "Handles cubesats, larger satellites, or entire rocket bodies",
          },
        ],
        href: CaptureNew,
      },
      // {
      //   title: "Honey Bee™ Asteroid Mining Vehicle",
      //   cards: [
      //     {
      //       description: "Key component for future asteroid mining operations",
      //     },
      //     {
      //       description: "Captures asteroids the size of houses containing swimming pool volumes of water",
      //     },
      //   ],
      //   href: Capture3,
      // },
    ],
  },
};
